const angular = require('angular');

function showMaxlengthCounterDirective() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attr, ngModel) {
            const maxlength = attr.maxlength || attr.ngMaxlength;
            const parentCounterEl = element.parent();
            const counterEl = angular.element('<div class="maxlengthCounter">');
            const srOverMaxLengthEl = angular.element(`<span class="sr-only" aria-live="assertive" role="alert">Limit reached. You can only have ${maxlength} characters in this field.</span>`);

            counterEl.text(String(maxlength));
            parentCounterEl.append(counterEl);

            function renderCharCount(value) {
                counterEl.text(String(value));
                return value;
            }

            scope.$watch(() => ngModel.$viewValue, (value) => {
                if (!value) {
                    renderCharCount(maxlength);
                    return;
                }
                if (angular.isNumber(value.length)) {
                    const charsLeft = maxlength - value.length;

                    // If the characters exceeds the maxlength, turn it red and also set it to 0
                    if (charsLeft >= 0) {
                        counterEl.removeClass('maxlengthCounter-error');
                        renderCharCount(charsLeft);
                    } else {
                        counterEl.addClass('maxlengthCounter-error');
                        renderCharCount(0);
                    }

                    // Screen-reader text for character limit
                    if (charsLeft > 0) {
                        srOverMaxLengthEl.remove();
                    } else {
                        parentCounterEl.append(srOverMaxLengthEl);
                    }
                }
            });
        },
    };
}

module.exports = {
    showMaxlengthCounter: showMaxlengthCounterDirective,
};



// WEBPACK FOOTER //
// ./src/olycommon/maxlengthcounter/maxlengthcounter.directive.js